<script lang="ts" setup>
import { useAppStore } from '@stores/app.store'
import { computed } from 'vue'
import ImageResolver from '@components/ui/ImageResolver.vue'
import { CATEGORY_VIRTUAL_PREFIX } from '@lib/models/category'
import { useGtm } from '@composables/useGtm'

const store = useAppStore()
const { trackClickCategory } = useGtm()

const categoriesLinks = computed(() => {
  if (!store.categories.length) return []
  return store.categories
    .filter((category) => !category.idCategory.startsWith(CATEGORY_VIRTUAL_PREFIX))
    .map((category, index) => {
      const image = category.imageUrl || category.products?.[0].imageUrl || 'images/placeholder.svg'

      return {
        idCategory: category.idCategory,
        title: category.title,
        image,
        index 
      }
    })
})
</script>

<template>
  <section
    v-if="categoriesLinks.length"
    v-dragscroll
    data-test="aside-categories"
    class="bg-white py-vh-12 flex flex-col gap-vh-16 rounded shadow-elevation-down max-h-full mcd-custom-scrollbar overflow-y-auto overflow-x-clip"
  >
    <RouterLink
      v-for="category in categoriesLinks"
      :key="category.idCategory"
      v-ripple
      data-test="aside-category-link"
      class="cursor-pointer w-full px-vw-16 min-h-vh-56 flex flex-row items-center gap-vw-16"
      :to="{ name: 'category', params: { categoryId: category.idCategory } }"
      @click="trackClickCategory({ categoryName: category.title.toLowerCase(), categoryIndex: category.index + 1  })"
    >
      <div class="relative h-vh-56 w-vw-56 min-w-vw-56 rounded-full bg-adk-secondaryIvory">
        <ImageResolver
          :url="category.image"
          :alt="category.title"
          class="absolute left-1/2 top-1/2 w-vw-48 h-auto -translate-x-1/2 -translate-y-1/2"
        />
      </div>
      <p class="text-small">{{ category.title }}</p>
    </RouterLink>
  </section>
</template>

<style scoped>
@reference "#main.css";
.router-link-exact-active {
  @apply relative bg-adk-secondaryIvory;
}

.router-link-exact-active::before {
  @apply absolute content-[''] h-full top-0 left-0 w-[calc(3*var(--vw))] bg-adk-main;
}

.router-link-exact-active p {
  @apply font-bold;
}

[data-test='aside-categories'] {
  scrollbar-gutter: auto;
}
</style>
